import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { prepareHtml } from "../lib/siteApi";

export function PhotoLink({ to, src, alt = "", className = "", wrapClassName = "", children }) {
  if (!src) return null;
  const img = <img src={src} alt={alt} className={className} />;
  if (!to) {
    return (
      <div className={`relative overflow-hidden ${wrapClassName}`}>
        {img}
        {children}
      </div>
    );
  }
  return (
    <Link to={to} className={`block relative overflow-hidden cursor-pointer ${wrapClassName}`}>
      {img}
      {children}
    </Link>
  );
}

function splitSections(html) {
  if (typeof DOMParser === "undefined" || !/<h2[\s>]/i.test(html)) return null;
  const doc = new DOMParser().parseFromString(`<div id="cms-root">${html}</div>`, "text/html");
  const root = doc.getElementById("cms-root");
  if (!root) return null;
  const intro = [];
  const sections = [];
  let current = null;
  Array.from(root.childNodes).forEach((node) => {
    const isHeading = node.nodeType === 1 && node.tagName === "H2";
    if (isHeading) {
      current = { title: node.textContent || "Section", html: "" };
      sections.push(current);
      return;
    }
    const chunk = node.nodeType === 1 ? node.outerHTML : node.textContent || "";
    if (!chunk.trim()) return;
    if (current) current.html += chunk;
    else intro.push(chunk);
  });
  if (!sections.length) return null;
  return { intro: intro.join(""), sections };
}

export default function HtmlContent({ html, className = "", imageTo }) {
  const navigate = useNavigate();
  const raw = html || "";
  const looksHtml = /<[a-z][\s\S]*>/i.test(raw);
  const safe = prepareHtml(raw, imageTo);
  const story = looksHtml ? splitSections(safe) : null;

  function onClick(event) {
    const anchor = event.target.closest("a");
    if (!anchor || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
    const href = anchor.getAttribute("href") || "";
    if (!href.startsWith("/") || href.startsWith("//")) return;
    event.preventDefault();
    navigate(href);
  }

  if (!looksHtml) {
    return <p className={className}>{raw}</p>;
  }
  if (story) {
    return (
      <div className={`cms-story ${className}`} onClick={onClick}>
        {story.intro ? <div className="cms-lead cms-content" dangerouslySetInnerHTML={{ __html: story.intro }} /> : null}
        <div className="cms-section-grid">
          {story.sections.map((section, index) => (
            <article key={`${section.title}-${index}`} className={`cms-panel ${index % 2 ? "is-shift" : ""}`}>
              <span className="cms-index">{String(index + 1).padStart(2, "0")}</span>
              <h2>{section.title}</h2>
              {section.html ? <div className="cms-content" dangerouslySetInnerHTML={{ __html: section.html }} /> : null}
            </article>
          ))}
        </div>
      </div>
    );
  }
  return <div className={`cms-content ${className}`} dangerouslySetInnerHTML={{ __html: safe }} onClick={onClick} />;
}
